import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { IntegrationDetailPage } from '@/pages/integrations/detail/IntegrationDetailPage'
import { parseAccountIntegrationSearch } from '@/pages/integrations/detail/integration-detail-search'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/integrations_/$providerSlug_/accounts/$connectionId'
)({
  validateSearch: parseAccountIntegrationSearch,
  component: IntegrationAccountDetailRoute,
  staticData: {
    pageHeader: {
      title: 'Integration account',
      customHeader: true,
      pad: false,
    },
  },
})

function IntegrationAccountDetailRoute() {
  const { workspaceId, auditCycleId, providerSlug, connectionId } = Route.useParams()
  const search = Route.useSearch()
  const navigate = useNavigate({ from: Route.fullPath })

  return (
    <IntegrationDetailPage
      workspaceId={workspaceId}
      auditCycleId={auditCycleId}
      providerSlug={providerSlug}
      accountConnectionId={connectionId}
      search={search}
      onSearchChange={(next) => navigate({ search: next })}
    />
  )
}
